import { Action } from '@ngrx/store';
import {
  TREQUEST_E8_MASTER_LISTING,
  TREQUEST_SEARCH_FATIGUE_ALLOWANCE_MASTER,
  TRESPONSE_BUNDLE_ALLOWANCE_MASTER,
  TRESPONSE_FATIGUE_ALLOWANCE_MASTER,
} from '@monorepo/types';
import { MastersActionType, TFetchCommonMasterListingSuccessPayload } from './masters.models';

export class FetchCommonMasterListing implements Action {
  readonly type = MastersActionType.FetchCommonMasterListing;
  constructor(
    public master: TFetchCommonMasterListingSuccessPayload['type'],
    public payload: TREQUEST_E8_MASTER_LISTING,
  ) {}
}
export class FetchCommonMasterListingSuccess implements Action {
  readonly type = MastersActionType.FetchCommonMasterListingSuccess;
  constructor(public payload: TFetchCommonMasterListingSuccessPayload) {}
}
export class FetchCommonMasterListingFailure implements Action {
  readonly type = MastersActionType.FetchCommonMasterListingFailure;
  constructor() {}
}

export class FetchFatigueAllowanceList implements Action {
  readonly type = MastersActionType.FetchFatigueAllowanceList;
  constructor(public searchRequest: TREQUEST_SEARCH_FATIGUE_ALLOWANCE_MASTER) {}
}
export class FetchFatigueAllowanceListSuccess implements Action {
  readonly type = MastersActionType.FetchFatigueAllowanceListSuccess;
  constructor(public res: TRESPONSE_FATIGUE_ALLOWANCE_MASTER) {}
}
export class FetchFatigueAllowanceListFailure implements Action {
  readonly type = MastersActionType.FetchFatigueAllowanceListFailure;
}

export class FetchBundleAllowance implements Action {
  readonly type = MastersActionType.FetchBundleAllowance;
}
export class FetchBundleAllowanceSuccess implements Action {
  readonly type = MastersActionType.FetchBundleAllowanceSuccess;
  constructor(public res: TRESPONSE_BUNDLE_ALLOWANCE_MASTER) {}
}
export class FetchBundleAllowanceFailure implements Action {
  readonly type = MastersActionType.FetchBundleAllowanceFailure;
}

export type TMastersActions =
  | FetchFatigueAllowanceList
  | FetchFatigueAllowanceListSuccess
  | FetchFatigueAllowanceListFailure
  | FetchBundleAllowance
  | FetchBundleAllowanceSuccess
  | FetchBundleAllowanceFailure
  | FetchCommonMasterListing
  | FetchCommonMasterListingSuccess
  | FetchCommonMasterListingFailure;
